import React from "react";
import { EditContentModalShell } from "./EditContentModalShell";
type EditContentErrorStateProps = {
    onClose: () => void;
    onRetry: () => void;
    onUseCachedData: () => void;
    fetchErrorMessage: string;
    fetchErrorDetails: string | null;
};

export const EditContentErrorState: React.FC<EditContentErrorStateProps> = ({
    onClose,
    onRetry,
    onUseCachedData,
    fetchErrorMessage,
    fetchErrorDetails,
}) => (
    <EditContentModalShell onClose={onClose}>
        <h3 style={{ color: "#e74c3c", marginBottom: "12px" }}>Failed to Load Content</h3>
        <p style={{ color: "#8B92A6", marginBottom: "18px" }}>{fetchErrorMessage}</p>
        {fetchErrorDetails && (
            <details
                style={{
                    marginBottom: "20px",
                    textAlign: "left",
                    background: "#ffffff",
                    borderRadius: "10px",
                    padding: "12px 16px",
                    border: "1px solid rgba(0,0,0,0.08)",
                }}
            >
                <summary style={{ cursor: "pointer", fontWeight: 600 }}>
                    Show technical details
                </summary>
                <pre
                    style={{
                        marginTop: "10px",
                        fontSize: "0.8rem",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        color: "#4b5563",
                    }}
                >
                    {fetchErrorDetails}
                </pre>
            </details>
        )}
        <div
            style={{
                display: "flex",
                gap: "12px",
                justifyContent: "center",
                flexWrap: "wrap",
            }}
        >
            <button onClick={onRetry} className="save-button" style={{ minWidth: "100px" }}>
                Retry
            </button>
            <button
                onClick={onUseCachedData}
                className="save-button"
                style={{
                    minWidth: "140px",
                    background: "linear-gradient(135deg, #6b7280, #4b5563)",
                }}
            >
                Edit
            </button>
            <button onClick={onClose} className="cancel-button" style={{ minWidth: "100px" }}>
                Cancel
            </button>
        </div>
    </EditContentModalShell>
);
